<template>
  <div class="app-options-view">
    <slot name="txtBefore"><h2>Optionen</h2></slot>
    <div v-if="options.length !== 0">
      <div class="summary-data-options">
        <div class="txt-options-booked">
          <slot name="txtOptionsBooked">Aktuell sind folgende Optionen für Sie gebucht:</slot>
        </div>
        <b-row class="data-line thead">
          <b-col md="" sm="" class="data-cell first">
            <slot name="txtOptionsHeader">Optionen</slot>
          </b-col>
          <b-col md="" sm="" class="data-cell second">
            <slot name="txtCosts">Regulärer Preis</slot>
          </b-col>
          <b-col md="" sm="" class="data-cell third">
            <slot name="txtStatus">Status</slot>
          </b-col>
        </b-row>
      </div>
      <div class="data-block-options" v-for="item in options" :key="item.id">
        <b-row class="data-line opts">
          <b-col md="" sm="" class="data-cell first name">
            <div class="option-name-block">
              <span v-html="item.name"></span>
              <span v-if="item.extraHtml" v-html="item.extraHtml"></span>
            </div>
          </b-col>
          <b-col md="" sm="" class="data-cell second price">
            <span v-if="item.price !== 0 && item.duration !== null">{{ price(item.price) }} / {{
                item.duration.amount
              }} {{ durationUnit(item.duration.unit) }}</span>
            <span v-else><slot name="txtForFree">kostenlos</slot></span>
          </b-col>
          <b-col md="" sm="" class="data-cell third status">
            <span v-if="item.status">
              <div :class="item.statusKey" class="status-heading" v-if="item.status.heading">{{
                  item.status.heading
                }}</div>
              <div v-if="item.status.message">{{ replaceWithDate(item) }}</div>
            </span>
            <span class="option-no-duration-info" v-if="item.duration !== null && !item.duration.amount"><slot name="txtNoDuration">Gültig bis: unbefristet</slot></span>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else class="no-options-booked">
      <slot name="noOptionsBooked">Aktuell sind keine Optionen gebucht.</slot>
    </div>
    <slot name="txtBeforeFormattedBalance" v-if="isBalanceSet">
      <div class="txt-before-formatted-balance">Ihr aktuelles Guthaben: {{ centsToEuros(balance) }}</div>
    </slot>
    <div class="change-options-links">
      <div class="book-options-link" v-if="optionBookable">
        <slot name="bookOptionsLink"><a @click="book">{{ stepBookLabel }}</a></slot>
      </div>
      <div class="deactivate-options-link" v-if="optionDeactivatable">
        <slot name="deactivateOptionsLink"><a @click="deactivate">{{ stepDeactivateLabel }}</a></slot>
      </div>
    </div>
  </div>
</template>

<script>

import price from '../../../../../mixins/price'
import durationUnit from '../../../../../mixins/durationUnit'
import { BCol, BRow } from 'bootstrap-vue'

export const stepName = 'view'
export default {
  name: 'OptionsView',
  components: {
    BRow, BCol
  },
  props: {
    options: {
      type: Array
    },
    balance: {
      type: Number,
      default: null
    },
    optionBookable: {
      type: Boolean,
      default: false
    },
    optionDeactivatable: {
      type: Boolean,
      default: false
    },
    stepBook: {
      type: String
    },
    stepDeactivate: {
      type: String
    },
    stepDeactivateLabel: {
      type: String
    },
    stepBookLabel: {
      type: String
    }
  },
  computed: {
    isBalanceSet () {
      return this.balance !== null
    }
  },
  methods: {
    replaceWithDate (item) {
      return item.status.message?.replace('%date%', this.$config.calendar.formatter.dateFormatter.format(new Date(item.endOfRuntime)))
    },
    book () {
      this.$emit('update-step', this.stepBook)
    },
    deactivate () {
      this.$emit('update-step', this.stepDeactivate)
    },
    centsToEuros (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(parseInt(value) / 100)
    }
  },
  mixins: [
    price,
    durationUnit
  ]
}
</script>
